import { SuperPower } from "./types";
import { Card } from "react-bootstrap";
import SectionHeader from "./SectionHeader";
import { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCollapsibleSection from "./useCollapsibleSection";

interface Props {
  readonly superPower: SuperPower | null;
  readonly forceExpanded?: boolean;
}

const TeamSuperPower = forwardRef<HTMLDivElement, Props>(
  function TeamSuperPower({ superPower, forceExpanded }, ref) {
    const { collapsed, toggleIsCollapsed } =
      useCollapsibleSection(forceExpanded);

    if (!superPower) {
      return null;
    }

    const getStrengthsOrRisksCard = (type: string) => {
      const title =
        type === "strengths"
          ? "Strengths Of This Superpower"
          : "Risks Of This Superpower";

      const bulletPoint =
        type === "strengths" ? (
          <FontAwesomeIcon icon="check" color="#009952" />
        ) : (
          <FontAwesomeIcon icon="times" color="#D50057" />
        );
      const arrayToMap =
        type === "strengths" ? superPower.strengths : superPower.risks;

      let counter = 0;
      return (
        <Card
          style={{ padding: "16px 20px" }}
          className="workplace-insights-simple-card"
        >
          <h3>{title}</h3>
          {arrayToMap.map((item) => {
            counter += 1;
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  paddingBottom: "10px",
                  paddingTop: "10px",
                  fontSize: "14px",
                }}
                key={counter}
              >
                {bulletPoint}
                <div style={{ paddingLeft: "10px" }}>{item}</div>
              </div>
            );
          })}
        </Card>
      );
    };

    if (collapsed) {
      return (
        <Card ref={ref}>
          <SectionHeader
            toggleIsCollapsed={toggleIsCollapsed}
            title="Team Superpower"
            isCollapsed={collapsed}
          />
        </Card>
      );
    }

    return (
      <Card ref={ref} className="column-gap-20px">
        <SectionHeader
          toggleIsCollapsed={toggleIsCollapsed}
          title="Team Superpower"
          isCollapsed={collapsed}
          hideActionButton={forceExpanded}
        />
        <div className="card-with-left-strip column-gap-8px dark-blue card workplace-insights-simple-card-with-side-strip">
          <div>
            <h3>{superPower.trait}</h3>
            <p>{superPower.summary}</p>
          </div>
        </div>
        <div className="responsive-two-column-container">
          {getStrengthsOrRisksCard("strengths")}
          {getStrengthsOrRisksCard("risks")}
        </div>
      </Card>
    );
  }
);

export default TeamSuperPower;
